'use client';

import React from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';
import { Table } from '@benzinga/table';
import { EarningsColumnsDef, EconomicsColumnsDef, RatingsColumnsDef } from '@benzinga/money';
import type { Earnings, Economics, Ratings } from '@benzinga/calendar-manager';

import styles from '../../../_components/markets/styles.module.scss';

interface PremarketCalendarSectionProps {
  earningsData: Earnings[];
  economicsData: Economics[];
  ratingsData: Ratings[];
  isWeekend: boolean;
}

export function PremarketCalendarSection({
  earningsData,
  economicsData,
  ratingsData,
  isWeekend,
}: PremarketCalendarSectionProps) {
  return (
    <div className={styles['block-container']}>
      <div className={styles['block-header']}>
        <h2>Today&apos;s Events</h2>
      </div>
      <div className={`${styles['block-content']} flex flex-col gap-4`}>
        <p className="text-sm text-gray-700 m-0 px-1">
          See our{' '}
          <a className="text-[#3F83F8] font-bold no-underline" href="/market-update">
            Market Update
          </a>{' '}
          for a full picture of everything happening in markets today.
        </p>
        <ErrorBoundary name="premarket-page-earnings-table">
          <Table
            columnsDef={EarningsColumnsDef}
            height={350}
            rowData={earningsData}
            seeMoreLink="https://www.benzinga.com/earnings"
            seeMoreText="Earnings"
            title={!isWeekend ? "Today's Earnings" : 'Upcoming Earnings'}
          />
        </ErrorBoundary>
        <ErrorBoundary name="premarket-page-ratings-table">
          <Table
            columnsDef={RatingsColumnsDef}
            height={350}
            rowData={ratingsData}
            seeMoreLink="https://www.benzinga.com/analyst-stock-ratings"
            seeMoreText="Analyst Ratings"
            title="Top Analyst Ratings"
          />
        </ErrorBoundary>
        <ErrorBoundary name="premarket-page-economics-table">
          <Table
            className="economics-table"
            columnsDef={EconomicsColumnsDef}
            rowData={economicsData}
            seeMoreLink="https://www.benzinga.com/calendars/economic"
            seeMoreText="Economics Data"
            title={!isWeekend ? "Today's Economic Data" : 'Upcoming Economic Data'}
          />
        </ErrorBoundary>
      </div>
    </div>
  );
}
